module.exports = __webpack_public_path__ + "static/media/country_sr.90975b05.webp";